/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import HealthEntryCategoryNames from '../../../../constants/HealthEntryCategoryNames';
import HealthEntryModel from '../../../../models/HealthEntry';
import { useActiveProfile } from '../../../hooks/useProfile';
import { useUIState } from '../../../hooks/useUIState';
import ProfileModel from '../../../../models/ProfileModel';
import OccurrenceFooter from './OccurrenceFooter';

const getReconsiderPhrase = (category, isMainProfile, profileName) => {
  let someCategory = '';

  switch (category) {
    case HealthEntryCategoryNames.condition:
      someCategory = 'conditions';
      break;
    case HealthEntryCategoryNames.allergy:
      someCategory = 'allergies';
      break;
    case HealthEntryCategoryNames.medication:
      someCategory = 'medications';
      break;
    case HealthEntryCategoryNames.otherTreatment:
      someCategory = 'treatments';
      break;
    default:
      break;
  }

  return {
    title: {
      id: `heDeleteConfirm.makePast.${someCategory}.heading`,
    },
    body: isMainProfile ? {
      id: 'heDeleteConfirm.makePast.user.message.pre',
    } : {
      id: 'heDeleteConfirm.makePast.notUser.message.pre',
      values: {
        string1: profileName,
      },
    },
    button: {
      id: 'heDeleteConfirm.makePast.button.label',
    },
    alternateButton: {
      id: 'heDeleteConfirm.delete.button.label',
    },
    cancel: {
      id: 'nav.cancel.button.label',
    },
  };
};

interface Props {
  healthEntry: any;
  healthEntryValue: any;
  onToggleFlag(): void;
  onDelete?(): void;
  onToggleIsCurrent?(): void;
  altLeftContent?: any;
  primaryButtonPhrase?: any;
}

const HealthEntryFooter: React.FC<Props> = (props) => {
  const { onDelete, onToggleFlag, altLeftContent, primaryButtonPhrase, onToggleIsCurrent, healthEntry, healthEntryValue } = props;

  const [activeProfileData] = useActiveProfile();
  const profile = new ProfileModel(activeProfileData.data);
  const profileName = profile.greetingName();
  const [uiState] = useUIState();

  const isMainProfile = uiState.isActiveProfileMainProfile;
  const isFlagged = healthEntryValue ? HealthEntryModel.isFlagged(healthEntryValue) : HealthEntryModel.isFlagged(healthEntry);
  const isCurrent = healthEntryValue ? false : HealthEntryModel.isCurrent(healthEntry);
  const category = healthEntry.category;

  return (
    <OccurrenceFooter
      onDelete={onDelete}
      onToggleFlag={onToggleFlag}
      altLeftContent={altLeftContent}
      primaryButtonPhrase={primaryButtonPhrase}
      onToggleIsCurrent={onToggleIsCurrent}
      isFlagged={isFlagged}
      shouldReconsiderDelete={HealthEntryModel.allowCurrent(category) && isCurrent}
      reconsiderPhraseMessages={getReconsiderPhrase(category, isMainProfile, profileName)}
    />
  );
};

export default HealthEntryFooter;
